import { createSnackbarQueue } from '@rmwc/snackbar';
import { createDialogQueue } from '@rmwc/dialog';

const messages = {
    snackbarQueue: createSnackbarQueue(),
    dialogQueue: createDialogQueue(),
};

export default messages;
